<lib-draggable-dialog-header [customStyles]="{ 'padding': '12px 0' }" [hideCloseIcon]="!data.showCloseIcon" class="dialog-header">
  <h1>Photo {{ data.index + 1 }} of {{ data.files.length }}</h1>
</lib-draggable-dialog-header>

<div class="dialog-body">
  <div #imageContainer class="image-gallery relative" [style.direction]="'row'" [style.align-items]="'center'">
    @for (file of data.files; track file; let i = $index) {
      <img [src]="file.url" [id]="'gallery-img' + i"
        [style.transform]="'rotate(' + rotations()[data.index] + 'deg)'"
        [style.max-width]="(rotations()[data.index] % 180 === 0) ? '100%' : `${imageContainerHeight()}px`"
        [style.max-height]="(rotations()[data.index] % 180 === 0) ? '100%' : `${imageContainerWidth()}px`"
        [class.photo-rejected]="file.rejected"
        class="img-responsive no-transition" [style.display]="data.index === i ? 'block' : 'none'" [file]="file" [showTimestamp]="false">
    }
  </div>

  <div class="actions" style="display: flex; justify-content: space-between;">
    <div class="btns row-layout">
      @if (requiresAction()) {
        <div id="file-status-buttons">
          @if (!currentFile.rejected) {
            <button class="btn btn-danger" (click)="setStatus(true)">Reject</button>
          }
          @if (currentFile.rejected) {
            <button class="btn btn-success" (click)="setStatus(false)">Approve</button>
          }
        </div>
      }
      <button class="btn btn-clear color-primary btn-lg" (click)="rotate()">
        <i class="icon ion-android-refresh"></i>
      </button>
    </div>

    <span></span>

    <div class="btns">
      @if (data.files.length > 1) {
        <button class="btn btn-clear color-primary btn-lg" (click)="previous()">
          <i class="icon ion-android-arrow-back"></i>
        </button>
      }
      @if (data.files.length > 1) {
        <button class="btn btn-clear color-primary btn-lg" (click)="next()">
          <i class="icon ion-android-arrow-forward"></i>
        </button>
      }
    </div>
  </div>
</div>

